import { Controller } from "stimulus"

// Switches which metric a history table shows without a page reload. Each
// cell carries the pre-formatted value for every metric in data attributes
// (data-revenue, data-units, data-orders).
export default class extends Controller {
  static targets = ["button", "cell"]

  select(event) {
    const metric = event.currentTarget.dataset.metric

    this.buttonTargets.forEach(button => {
      const active = button.dataset.metric === metric
      button.classList.toggle("btn-secondary", active)
      button.classList.toggle("btn-outline-secondary", !active)
    })

    this.cellTargets.forEach(cell => { cell.textContent = cell.dataset[metric] })
  }
}
